/* tslint:disable */
import {
  PropertyUnits,
  UnitFeature
} from '../index';

declare var Object: any;
export interface PropertyUnitFeatureInterface {
  "property_unit_id": number;
  "unit_feature_id": number;
  "id"?: number;
  "createdAt": Date;
  "updatedAt": Date;
  "deletedAt"?: Date;
  propertyUnits?: PropertyUnits;
  unitFeature?: UnitFeature;
}

export class PropertyUnitFeature implements PropertyUnitFeatureInterface {
  "property_unit_id": number;
  "unit_feature_id": number;
  "id": number;
  "createdAt": Date;
  "updatedAt": Date;
  "deletedAt": Date;
  propertyUnits: PropertyUnits;
  unitFeature: UnitFeature;
  constructor(data?: PropertyUnitFeatureInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `PropertyUnitFeature`.
   */
  public static getModelName() {
    return "PropertyUnitFeature";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of PropertyUnitFeature for dynamic purposes.
  **/
  public static factory(data: PropertyUnitFeatureInterface): PropertyUnitFeature{
    return new PropertyUnitFeature(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'PropertyUnitFeature',
      plural: 'PropertyUnitFeatures',
      path: 'PropertyUnitFeatures',
      idName: 'id',
      properties: {
        "property_unit_id": {
          name: 'property_unit_id',
          type: 'number'
        },
        "unit_feature_id": {
          name: 'unit_feature_id',
          type: 'number'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
        "createdAt": {
          name: 'createdAt',
          type: 'Date'
        },
        "updatedAt": {
          name: 'updatedAt',
          type: 'Date'
        },
        "deletedAt": {
          name: 'deletedAt',
          type: 'Date',
          default: new Date(0)
        },
      },
      relations: {
        propertyUnits: {
          name: 'propertyUnits',
          type: 'PropertyUnits',
          model: 'PropertyUnits',
          relationType: 'belongsTo',
                  keyFrom: 'property_unit_id',
          keyTo: 'id'
        },
        unitFeature: {
          name: 'unitFeature',
          type: 'UnitFeature',
          model: 'UnitFeature',
          relationType: 'belongsTo',
                  keyFrom: 'unit_feature_id',
          keyTo: 'id'
        },
      }
    }
  }
}
